import { matchPath } from "react-router-dom";
import { RESPONSIVE_ROUTES } from "../const/routesConst";

export const isResponsiveRoute = (pathname: string) => {
  return RESPONSIVE_ROUTES.some((route) =>
    matchPath({ path: route, end: true }, pathname)
  );
};
